module.exports = __webpack_public_path__ + "img/run_pro_mini.5d3530b9.webp";